<div class="p-2 p-md-0">
  <div class="d-flex flex-column align-items-center">
    <div class="d-flex justify-content-center w-100">
      <img [alt]="qrCodeUrl()" [attr.data-e2e]="e2e() + '-image'" [src]="qrCodeUrl() | qrCode: 171 | async" />
    </div>
    <p class="text-center standard mt-1 mb-2 mb-md-0 text-gray3" style="max-width: 350px">
      {{ i18nPath + '.subTitle' | translate }}
    </p>
  </div>
</div>
